import React, { useEffect, useState } from "react";
import "./MessageCodes.css";

const POPRredirect = (props) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    props.setisSubscriber(false);
  }, []);

  const handleClick = () => {
    if (props.disable) return;
    props?.setShowUrlPopUp({isActive : true , url :props?.item?.url });
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className="a1-wrap" style={{ width: "fit-content", margin: "6px", cursor: "pointer" }}>
      {/* Clickable Button */}
      <a
        className="chat-label action-tab"
        style={{ color: props.disable ? "grey" : "black" }}
        href={props?.item?.url}
        target="_blank"
        rel="noopener noreferrer"
        // onClick={handleClick}
      >
        {props?.item?.text}
      </a>

    </div>
  );
};

export default POPRredirect;
